import { render, staticRenderFns } from "./training-summary-report.vue?vue&type=template&id=0c38c8be&scoped=true"
import script from "./training-summary-report.vue?vue&type=script&lang=js"
export * from "./training-summary-report.vue?vue&type=script&lang=js"
import style0 from "./training-summary-report.vue?vue&type=style&index=0&id=0c38c8be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c38c8be",
  null
  
)

export default component.exports